import type { AlpineComponent } from 'alpinejs'
import Swiper from 'swiper'
import { Pagination, EffectFade, Autoplay, Navigation } from 'swiper/modules'
import type { SwiperOptions } from 'swiper/types'
import 'swiper/css/bundle'
import 'swiper/css/pagination'

// if better types get needed check
// https://github.com/alpinejs/alpine/issues/2199#issuecomment-1809892127

export function Slider(config: SwiperOptions): AlpineComponent<{
  swiper: Swiper | undefined
  init(): void
  discard(): void
}> {
  const defaultConfig: SwiperOptions = {
    modules: [Pagination, EffectFade, Autoplay, Navigation],
    slidesPerView: 1,
    loop: false,
    spaceBetween: 30,
    pagination: {
      el: this.$refs.pagination,
      type: 'bullets',
      clickable: true,
    },
  }

  return {
    swiper: undefined,

    init() {
      this.swiper = new Swiper(this.$refs.slider, {
        ...defaultConfig,
        ...config,
      })
    },

    discard() {
      this.swiper && this.swiper.destroy()
    },
  }
}
